import showOnScroll, { emptyTransition, fadeSlideUp } from '@zerofool/show-on-scroll';
import $ from 'jquery';

$(() => {

	if ($('.steps').length === 0) return;

	showOnScroll(
		'.steps__item',
		{
			...emptyTransition,
			observerOptions: {threshold: .9}
		},
		el => {
			el.classList.add('show');
		}
	);

	showOnScroll('.steps__content', fadeSlideUp);
	showOnScroll('.steps__title', fadeSlideUp);

});
